module.exports = __webpack_public_path__ + "img/logo.0a7d0135.png";